export const LogicalReflectorSymbol = Symbol('LogicalReflector')
export const LogicalReflectorStateSymbol = Symbol('LogicalReflectorState')
export const FragmentStoresInitializerSymbol = Symbol('FragmentStoresInitializer')

export const name = 'pages' as const
